
import React from "react";
import { useAboutUs } from "@/hooks/useAboutUs";
import { Skeleton } from "@/components/ui/skeleton";
import { Footer } from "@/components/Footer";
import { Header } from "@/components/Header";

const AboutUs = () => {
  const { aboutUs, isLoading } = useAboutUs();
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header showSearchAndLocation={false} />
      
      <main className="flex-1 pt-32 pb-12">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-4xl md:text-5xl font-bold mb-4 text-foreground tracking-tight">About Us</h1>
              <div className="w-24 h-1 bg-primary mx-auto rounded-full"></div>
            </div>
            
            {isLoading ? (
              <div className="space-y-6">
                <Skeleton className="h-16 w-3/4 mx-auto" />
                <Skeleton className="h-6 w-full" />
                <Skeleton className="h-6 w-full" />
                <Skeleton className="h-6 w-4/5" />
                <Skeleton className="h-32 w-full" />
              </div>
            ) : (
              <article 
                className="prose prose-xl max-w-none 
                         prose-headings:text-foreground prose-headings:font-semibold prose-headings:tracking-tight prose-headings:mb-6
                         prose-p:text-muted-foreground prose-p:leading-relaxed prose-p:mb-6
                         prose-li:text-muted-foreground prose-li:leading-relaxed
                         prose-ul:space-y-3 prose-ol:space-y-3
                         prose-ul:pl-6 prose-ol:pl-6
                         prose-strong:text-foreground prose-strong:font-semibold
                         prose-h4:text-2xl prose-h4:text-foreground prose-h4:font-semibold prose-h4:mb-8 prose-h4:leading-tight
                         first-letter:text-4xl first-letter:font-bold first-letter:text-primary first-letter:float-left first-letter:mr-2 first-letter:mt-1"
                dangerouslySetInnerHTML={{ __html: aboutUs.content }}
              />
            )}
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default AboutUs;
